import React from "react";
import { ChatBubbleLeftRightIcon } from "@heroicons/react/24/outline";
import classNames from "classnames";

export default function ChatLauncher({ unreadCount = 0, onClick }) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={classNames(
        "fixed bottom-5 right-5 z-[60] shadow-lg rounded-full",
        "bg-primary-600 hover:bg-primary-700 text-white",
        "h-12 w-12 flex items-center justify-center"
      )}
      style={{
        right: "calc(1.25rem + var(--right-sidebar-offset, 0px))",
      }}
      title="Messages"
    >
      <ChatBubbleLeftRightIcon className="h-6 w-6" />
      {unreadCount > 0 && (
        <span className="absolute -top-1 -right-1 inline-flex items-center justify-center min-w-[18px] h-[18px] px-1 text-[10px] font-bold text-white bg-red-500 rounded-full">
          {unreadCount > 99 ? "99+" : unreadCount}
        </span>
      )}
    </button>
  );
}
